import MenuItem from 'material-ui/MenuItem'
import Formsy from 'formsy-react'
import { FormsyText, FormsyCheckbox, FormsySelect } from 'formsy-material-ui'
import { Button, Loading, Notice } from 'components'
import { default as SEVERITY_ICONS } from 'components/icons/SeverityIcons'

import { capitalize } from 'utils/Functions'
import { ISOCountries } from 'utils/Enum'

import './editLocalBusiness.scss'

export default class EditLocalBusiness extends React.Component {
  static propTypes = {
    data:       React.PropTypes.object.isRequired,
    details:    React.PropTypes.object,
    noDetails:  React.PropTypes.bool,
    onSave:     React.PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    const { data, noDetails } = this.props

    this.state = {
      display: this.props.data.structuredDataDisplayLocalBusiness,
      initializing: false,
      editMode: {
        contact: noDetails && !this.isContactDefined(),
        address: noDetails && !this.isAddressDefined(),
      },
      saving: {
        contact: false,
        address: false,
      },
    }
  }

  isContactDefined() {
    return this.props.data.structuredDataBusinessName
  }

  isAddressDefined() {
    return this.props.data.structuredDataStreet
  }

  toggleEdit(key) {
    const { editMode } = this.state

    this.setState({
      editMode: {
        ...editMode,
        [key]: !editMode[key],
      },
    })
  }

  toggleSaving(key) {
    const { saving } = this.state

    this.setState({
      saving: {
        ...saving,
        [key]: !saving[key],
      },
    })
  }

  toggleDisplay(display) {
    if (display && !this.isContactDefined() && !this.isAddressDefined()) {
      this.initContent()
      return
    }

    this.setState({ display })
    this.save({ structuredDataDisplayLocalBusiness: display })
  }

  initContent() {
    const { details, noDetails } = this.props
    if (noDetails) {
      this.setState({ display: true })
      return
    }

    const data = {
      structuredDataDisplayLocalBusiness: true,
      structuredDataBusinessName: details['businessName'],
      structuredDataShopUrl: details['shopUrl'],
      structuredDataBusinessEmail: details['businessEmail'],
      structuredDataContactPhone: details['contactPhone'],
      structuredDataStreet: details['street'],
      structuredDataLocality: details['locality'],
      structuredDataRegion: details['region'],
      structuredDataCountry: details['country'],
      structuredDataPostalCode: details['postalCode'],
    }

    this.setState({
      display: true,
      initializing: true,
    })

    this.save(data).then(() => {
      this.setState({ initializing: false })
    })
  }

  saveContent(data, key) {
    this.toggleSaving(key)

    this.save({
      structuredDataDisplayLocalBusiness: true,
      ...data,
    }).then(() => {
      this.toggleSaving(key)
      this.toggleEdit(key)
    })
  }

  save(data) {
    return this.props.onSave(data)
  }

  renderContactSection() {
    const editMode = this.state.editMode.contact
    const saving = this.state.saving.contact
    const { data } = this.props

    return (
      <div className="edit-local-business__section contact">
        <h4 className="small-spacing--bottom">Contact Information</h4>
        {editMode ?
          <div className="editable">
            <Formsy.Form onValidSubmit={d => this.saveContent(d, 'contact')}>
              <FormsyText
                defaultValue={data.structuredDataBusinessName}
                name="structuredDataBusinessName"
                placeholder="Add your shop name"
                fullWidth={true}
                required
              />
              <FormsyText
                defaultValue={data.structuredDataShopUrl}
                name="structuredDataShopUrl"
                placeholder="Add your shop url"
                fullWidth={true}
                validations='isUrl'
                validationError='Please enter valid Url'
                required
              />
              <FormsyText
                defaultValue={data.structuredDataBusinessEmail}
                name="structuredDataBusinessEmail"
                placeholder="Add your business email"
                validations='isEmail'
                validationError='Please enter valid Email'
                fullWidth={true}
              />
              <FormsyText
                defaultValue={data.structuredDataContactPhone}
                name="structuredDataContactPhone"
                placeholder="Add your phone number"
                fullWidth={true}
              />
              <div className="row--action">
                <Button
                  type="Submit"
                  label={saving ? 'Saving...' : 'Save'}
                  disabled={saving}
                  buttonType="primary"
                />
                {this.isContactDefined() && !saving &&
                  <Button
                    type="Button"
                    label="Cancel"
                    buttonType="secondary"
                    className="small-spacing2--left"
                    onTouchTap={() => this.toggleEdit('contact')}
                  />
                }
              </div>
            </Formsy.Form>
          </div> :
          <div className="static">
            <div className="row--data">{data.structuredDataBusinessName}</div>
            <div className="row--data">{data.structuredDataShopUrl}</div>
            {data.structuredDataBusinessEmail &&
              <div className="row--data">{data.structuredDataBusinessEmail}</div>
            }
            {data.structuredDataContactPhone &&
              <div className="row--data">{data.structuredDataContactPhone}</div>
            }
            <div className="row--action">
              <Button
                label="Edit"
                buttonType="secondary"
                onTouchTap={() => this.toggleEdit('contact')}
              />
            </div>
          </div>
        }
      </div>
    )
  }

  renderAddressSection() {
    const editMode = this.state.editMode.address
    const saving = this.state.saving.address
    const { data } = this.props

    return (
      <div className="edit-local-business__section address">
        <h4 className="small-spacing--bottom">Shop Address</h4>
        {editMode ?
          <div className="editable">
            <Formsy.Form onValidSubmit={d => this.saveContent(d, 'address')}>
              <FormsyText
                defaultValue={data.structuredDataStreet}
                name="structuredDataStreet"
                placeholder="Add your street address"
                fullWidth={true}
                required
              />
              <FormsyText
                defaultValue={data.structuredDataLocality}
                name="structuredDataLocality"
                placeholder="Add your city"
                fullWidth={true}
                required
              />
              <FormsyText
                defaultValue={data.structuredDataRegion}
                name="structuredDataRegion"
                placeholder="Add your state/province"
                fullWidth={true}
                required
              />
              <div className="country-selector">
                <FormsySelect
                  value={data.structuredDataCountry || ''}
                  name="structuredDataCountry"
                  menuStyle={{ height: 'auto' }}
                  fullWidth={true}
                  required
                >
                  <MenuItem value="" disabled primaryText="Select your country" />
                  {Object.keys(ISOCountries).map(code =>
                    <MenuItem value={code} primaryText={ISOCountries[code]} key={code} />
                  )}
                </FormsySelect>
              </div>
              <FormsyText
                defaultValue={data.structuredDataPostalCode}
                name="structuredDataPostalCode"
                placeholder="Add your postal/zip code"
                fullWidth={true}
                required
              />
              <div className="row--action">
                <Button
                  type="Submit"
                  label={saving ? 'Saving...' : 'Save'}
                  disabled={saving}
                  buttonType="primary"
                />
                {this.isAddressDefined() && !saving &&
                  <Button
                    type="Button"
                    label="Cancel"
                    buttonType="secondary"
                    className="small-spacing2--left"
                    onTouchTap={() => this.toggleEdit('address')}
                  />
                }
              </div>
            </Formsy.Form>
          </div> :
          <div className="static">
            <div className="row--data">{data.structuredDataStreet}</div>
            <div className="row--data">{data.structuredDataLocality}, {data.structuredDataRegion}</div>
            <div className="row--data">{ISOCountries[data.structuredDataCountry] || data.structuredDataCountry}</div>
            <div className="row--data">{data.structuredDataPostalCode}</div>
            <div className="row--action">
              <Button
                label="Edit"
                buttonType="secondary"
                onTouchTap={() => this.toggleEdit('address')}
              />
            </div>
          </div>
        }
      </div>
    )
  }

  renderMissingLogoError() {
    return (
      <Notice error header="Logo is missing">
        Please upload a logo to show Local Business data.
      </Notice>
    )
  }

  renderStatus() {
    const { display, initializing } = this.state
    const hasLogo = this.props.data.structuredDataDisplayLogo

    if (initializing) return null
    if (!display) return SEVERITY_ICONS.optional
    if (!hasLogo) return SEVERITY_ICONS.warning

    return SEVERITY_ICONS.info
  }

  render() {
    const { display, initializing } = this.state
    const hasLogo = this.props.data.structuredDataDisplayLogo

    return (
      <div className="seosettings__row edit-local-business xxlarge-spacing--top">
        <div className="edit-local-business__header">
          <h3 className="small-spacing--bottom">
            {this.renderStatus()}
            Do you have a physical location?
          </h3>
          <Formsy.Form>
            <FormsyCheckbox
              value={this.state.display}
              label="Display my local business information"
              name="visibility"
              onChange={(_evt, val) => this.toggleDisplay(val)}
            />
          </Formsy.Form>
        </div>

        {display && !initializing &&
          <div className="edit-local-business__body">
            { !hasLogo && this.renderMissingLogoError() }

            {this.renderContactSection()}
            {this.renderAddressSection()}
          </div>
        }

        {initializing &&
          <div className="edit-local-business__loading">
            <Loading />
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/EditLocalBusiness.js